import { format } from "timeago.js";

export const formatEpoch = (epochSeconds) => {
  return format(epochSeconds * 1000);
};
